<template>
  <div class="Product">
    <Topbar title="Sélection" backButton />

    <ProductDetail v-if="product" v-bind="product" :universe="universe" />
    <div class="Product__placeholder" v-else></div>

    <section class="Section" v-if="hotOffers.length > 0">
      <div class="Section__header">
        <h2 class="Section__title">Envie d'en voir plus ?</h2>
      </div>
      <div class="ProductList ProductList--compact">
        <router-link :to="{ name: 'Product', params: { id: offer.id }}" v-for="offer in hotOffers" :key="offer.id">
          <ProductCard v-bind="offer" />
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductDetail from "../components/ProductDetail";
import ProductCard from "../components/ProductCard";
import productService from "../services/product";
import universeService from "../services/universe";

export default {
  data() {
    return {
      product: null,
      universe: null,
      hotOffers: []
    };
  },
  computed: {
    ...mapGetters("auth", ["agent"])
  },
  created() {
    if (this.$route.params.universe_id) {
      universeService.get(this.$route.params.universe_id)
        .then(({ data: universe }) => this.universe = universe);
    }

    productService.get(this.$route.params.id)
      .then(({ data: product }) => this.product = product);

    productService.getOffers()
      .then(({ data: offers }) => this.hotOffers = offers.filter(offer => offer.id !== parseInt(this.$route.params.id)).sort((a, b) => 0.5 - Math.random()).slice(0, 4));
  },
  components: { ProductDetail, ProductCard }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';

.Product {
  &__placeholder {
    min-height: 60vh;
    background: linear-gradient(50deg, $color-smoke, transparent);
  }
}
</style>
